var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lms-checkbox",class:{
    'check-box': _vm.isTypeCheckBox,
    'pointer-events-none': _vm.isSending || _vm.isQuestionCompleted,
    'lms-checkbox--small': _vm.size === 'sm',
  }},[_c('input',{attrs:{"type":"checkbox","id":this._uid,"disabled":_vm.checked && !_vm.isTypeCheckBox},domProps:{"checked":_vm.checked},on:{"click":function($event){return _vm.$emit('change')}}}),_c('label',{attrs:{"for":this._uid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }